import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

const useGetLatestUserEvents = ({ useruuid, deviceuuid, envEventTypes }, options) => {
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  return useApiQuery(
    ['getLatestUserEvents', useruuid, deviceuuid, envEventTypes.join(',')],
    () =>
      new Promise((resolve, reject) => {
        userEventsApi.getLatestUserEvents(
          useruuid,
          {
            deviceuuid: [deviceuuid],
            eventtypes: envEventTypes,
          },
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data['user_events']);
            },
            errorCallback: () => {
              reject([]);
            },
            failCallback: () => {
              reject([]);
            },
          })
        );
      }),
    { enabled: !!useruuid && !!deviceuuid && envEventTypes.length > 0, ...options }
  );
};

export default useGetLatestUserEvents;
